<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Catalogo de Medicinas</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
        class="
          intro-y
          col-span-12
          flex flex-wrap
          sm:flex-nowrap
          items-center
          mt-2
        "
      >
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-72 relative text-gray-700 dark:text-gray-300">
            <input
              v-model="search"
              type="text"
              class="form-control w-72 box pr-10 placeholder-theme-13"
              placeholder="Buscar"
              @change="setFirstPage"
            />
            <SearchIcon
              class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
            />
          </div>
        </div>
        <div class="hidden md:block mx-auto text-gray-600"></div>
        <button
          class="btn btn-success shadow-md mr-2 w-60"
          @click="showModalCreate"
        >
          Nueva medicina
        </button>
        <button
          class="btn btn-info shadow-md mr-2 w-60"
          @click="downloadReport"
        >
          Descargar reporte
        </button>
      </div>
      <!-- BEGIN: Data List -->
      <template v-if="medicines">
        <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table
            class="table table-report -mt-2"
            aria-describedby="administrators table"
          >
            <thead>
              <tr>
                <th id="nombre" class="text-center whitespace-nowrap">
                  Nombre
                </th>
                <th id="KEYNAME" class="text-center whitespace-nowrap">
                  Key Name
                </th>
                <th id="proveedor" class="text-center whitespace-nowrap">
                  Proveedor
                </th>
                <th id="proveedorprecio" class="text-center whitespace-nowrap">
                  Precio de proveedor
                </th>
                <th id="ventaprice" class="text-center whitespace-nowrap">
                  Precio de venta
                </th>
                <th id="actionsH" class="text-center whitespace-nowrap">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr :key="row.id" v-for="row in elements">
                <td class="text-center w-10 font-medium">
                  {{ row.name }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.key_name }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.provider }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.price }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.sale_price }}
                </td>
                <td class="table-report__action w-56">
                  <div class="flex justify-center items-center">
                    <a
                      class="flex items-center mr-3 text-green-600"
                      href="javascript:;"
                      @click="setToEdit(row)"
                    >
                      <CheckSquareIcon class="w-4 h-4 mr-1" />
                      Editar
                    </a>
                    <a
                      href="javascript:;"
                      class="flex items-center text-red-700"
                      @click="setToDelete(row)"
                    >
                      <Trash2Icon class="w-4 h-4 mr-1" /> Eliminar
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END: Data List -->
        <!-- BEGIN: Pagination -->
        <div
          class="
            intro-y
            col-span-12
            flex flex-wrap
            sm:flex-row sm:flex-nowrap
            items-center
            py-10
          "
          v-if="pages > 1"
        >
          <ul class="pagination ml-auto" style="margin-right: revert;">
            <li @click="setFirstPage" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronsLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="changePageNegative" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li
              :key="element"
              v-for="element in [...Array(maxShowButtonPages).keys()].map(
                (dataElement, index) =>
                  activeGroup * maxShowButtonPages -
                  (maxShowButtonPages - index) +
                  1
              )"
            >
              <template v-if="element <= pages">
                <a
                  class="pagination__link"
                  href="javascript:;"
                  @click="page = element"
                  :class="{ 'pagination__link--active': element === page }"
                  >{{ element }}
                </a>
              </template>
            </li>
            <li v-if="page !== pages" @click="changePagePositive">
              <a class="pagination__link" href="javascript:;">
                <ChevronRightIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="setlastPage" v-if="page !== pages">
              <a class="pagination__link" href="javascript:;">
                <ChevronsRightIcon class="w-4 h-4" />
              </a>
            </li>
          </ul>
        </div>
        <!-- END: Pagination -->
      </template>
    </div>
    <!-- BEGIN: MODALS -->

    <!-- BEGIN: Modal Add Row -->
    <div ref="createRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="createAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">Nuevo medicina</h2>
              <a data-dismiss="modal" href="javascript:;">
                <XIcon class="w-5 h-5 text-gray-500" />
              </a>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Nombre</label>
                <input
                  v-model="createForm.name"
                  type="text"
                  class="form-control"
                  placeholder="Nombre"
                  required
                />
                <template v-if="v$.createForm.name.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">ID-MED</label>
                <input
                  v-model="createForm.id_med"
                  type="text"
                  class="form-control"
                  placeholder="ID-MED"
                  required
                />
                <template v-if="v$.createForm.id_med.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.id_med.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Key Name</label>
                <input
                  v-model="createForm.key_name"
                  type="text"
                  class="form-control"
                  placeholder="Key Name"
                  required
                />
                <template v-if="v$.createForm.key_name.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.key_name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Presentación</label>
                <input
                  v-model="createForm.presentation"
                  type="text"
                  class="form-control"
                  placeholder="Presentación"
                  required
                />
                <template v-if="v$.createForm.presentation.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.presentation.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Unidades</label>
                <input
                  v-model="createForm.units"
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="Unidades"
                  required
                />
                <template v-if="v$.createForm.units.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.units.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Proveedor</label>
                <input
                  v-model="createForm.provider"
                  type="text"
                  class="form-control"
                  placeholder="Proveedor"
                  required
                />
                <template v-if="v$.createForm.provider.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.provider.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Prescripción</label>
                <input
                  v-model="createForm.prescription"
                  type="text"
                  class="form-control"
                  placeholder="Prescripción"
                />
                <template v-if="v$.createForm.prescription.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.prescription.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Precio Proveedor</label>
                <input
                  v-model="createForm.price"
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="Precio Proveedor"
                  required
                />
                <template v-if="v$.createForm.price.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.price.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Precio Venta</label>
                <input
                  v-model="createForm.sale_price"
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="Precio Venta"
                  required
                />
                <template v-if="v$.createForm.sale_price.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.sale_price.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer text-right">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-20 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="v$.createForm.$invalid"
                class="btn btn-primary w-20"
                :class="{ 'btn-danger': v$.createForm.$invalid }"
              >
                Crear
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Add Row -->

    <!-- BEGIN: Delete Confirmation Modal -->
    <div ref="deleteRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div v-if="rowSelected" class="modal-body p-0">
            <div class="p-5 text-center">
              <XCircleIcon class="w-16 h-16 text-red-700 mx-auto mt-3" />
              <div class="text-3xl mt-5">¿Estás seguro?</div>
              <div class="text-gray-600 mt-2">
                ¿Realmente quieres eliminar el registro
                <span style="font-weight: bold">{{ rowSelected.name }}</span
                >?
              </div>
            </div>
            <div class="px-5 pb-8 text-center">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-24 mr-1"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-danger w-24"
                @click="deleteAction"
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Delete Confirmation Modal -->

    <!-- BEGIN: Modal Edit Row -->
    <div ref="editRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="editAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">Editar cliente</h2>
              <a data-dismiss="modal" href="javascript:;">
                <XIcon class="w-5 h-5 text-gray-500" />
              </a>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Nombre</label>
                <input
                  v-model="editForm.name"
                  type="text"
                  class="form-control"
                  placeholder="Nombre"
                  required
                />
                <template v-if="v$.editForm.name.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">ID-MED</label>
                <input
                  v-model="editForm.id_med"
                  type="text"
                  class="form-control"
                  placeholder="ID-MED"
                  required
                />
                <template v-if="v$.editForm.id_med.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.id_med.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Key Name</label>
                <input
                  v-model="editForm.key_name"
                  type="text"
                  class="form-control"
                  placeholder="Key Name"
                  required
                />
                <template v-if="v$.editForm.key_name.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.key_name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Presentación</label>
                <input
                  v-model="editForm.presentation"
                  type="text"
                  class="form-control"
                  placeholder="Presentación"
                  required
                />
                <template v-if="v$.editForm.presentation.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.presentation.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Unidades</label>
                <input
                  v-model="editForm.units"
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="Unidades"
                  required
                />
                <template v-if="v$.editForm.units.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.units.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Proveedor</label>
                <input
                  v-model="editForm.provider"
                  type="text"
                  class="form-control"
                  placeholder="Proveedor"
                  required
                />
                <template v-if="v$.editForm.provider.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.provider.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Prescripción</label>
                <input
                  v-model="editForm.prescription"
                  type="text"
                  class="form-control"
                  placeholder="Prescripción"
                />
                <template v-if="v$.editForm.prescription.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.prescription.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Precio Proveedor</label>
                <input
                  v-model="editForm.price"
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="Precio Proveedor"
                  required
                />
                <template v-if="v$.editForm.price.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.price.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Precio Venta</label>
                <input
                  v-model="editForm.sale_price"
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="Precio Venta"
                  required
                />
                <template v-if="v$.editForm.sale_price.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.sale_price.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                  </div>
                </template>
              </div>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer text-right">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-20 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="v$.editForm.$invalid"
                class="btn btn-primary w-20"
                :class="{ 'btn-danger': v$.editForm.$invalid }"
              >
                Modificar
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Edit Row -->

    <!-- END: MODALS -->
  </div>
</template>

<script>
import { cleanSession, getFirstErrorMessage } from '../../../utils/tools'
import useVuelidate from '@vuelidate/core'
import { maxLength, required } from '@vuelidate/validators'
import { saveAs } from 'file-saver'
import moment from 'moment-timezone'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      medicines: undefined,
      rowSelected: undefined,
      createForm: {
        id_med: '',
        key_name: '',
        name: '',
        prescription: '',
        presentation: '',
        price: '',
        provider: '',
        sale_price: '',
        units: ''
      },
      editForm: {
        id_med: '',
        key_name: '',
        name: '',
        prescription: '',
        presentation: '',
        price: '',
        provider: '',
        sale_price: '',
        units: ''
      },
      search: '',
      elementsByPage: 10,
      maxShowButtonPages: 3,
      page: 1,
      activeGroup: 1
    }
  },
  validations() {
    return {
      createForm: {
        id_med: { required, $autoDirty: true, maxLength: maxLength(100) },
        key_name: { required, $autoDirty: true, maxLength: maxLength(100) },
        name: { required, $autoDirty: true, maxLength: maxLength(100) },
        prescription: { $autoDirty: true, maxLength: maxLength(100) },
        presentation: { required, $autoDirty: true, maxLength: maxLength(100) },
        price: { required, $autoDirty: true },
        provider: { required, $autoDirty: true, maxLength: maxLength(100) },
        sale_price: { required, $autoDirty: true },
        units: { required, $autoDirty: true }
      },
      editForm: {
        id_med: { required, $autoDirty: true, maxLength: maxLength(100) },
        key_name: { required, $autoDirty: true, maxLength: maxLength(100) },
        name: { required, $autoDirty: true, maxLength: maxLength(100) },
        prescription: { $autoDirty: true, maxLength: maxLength(100) },
        presentation: { required, $autoDirty: true, maxLength: maxLength(100) },
        price: { required, $autoDirty: true },
        provider: { required, $autoDirty: true, maxLength: maxLength(100) },
        sale_price: { required, $autoDirty: true },
        units: { required, $autoDirty: true }
      }
    }
  },
  validationConfig: {
    $lazy: false
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    await this.getInitialData()
    this.$store.commit('main/setShowSpinner', false)
  },
  methods: {
    async getInitialData() {
      try {
        const response = await this.axios.get('/medicines', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.medicines = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    changePagePositive() {
      const page = this.page + 1
      if (page > this.activeGroup * this.maxShowButtonPages) {
        this.activeGroup++
      }
      this.page++
    },
    changePageNegative() {
      const page = this.page - 1
      if (page <= (this.activeGroup - 1) * this.maxShowButtonPages) {
        this.activeGroup = this.activeGroup - 1 === 0 ? 1 : this.activeGroup - 1
      }
      this.page--
    },
    setFirstPage() {
      this.page = 1
      this.activeGroup = 1
    },
    setlastPage() {
      this.page = this.pages
      this.activeGroup = this.totalGroups
    },
    showModalCreate() {
      this.createForm = {
        id_med: '',
        key_name: '',
        name: '',
        prescription: '',
        presentation: '',
        price: '',
        provider: '',
        sale_price: '',
        units: ''
      }
      this.v$.$reset()
      const modal = this.$refs.createRow
      cash(modal).modal('show')
    },
    async createAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.createRow
      cash(modal).modal('hide')
      try {
        await this.axios.post(
          '/create-medicine',
          {
            name: this.createForm.name,
            id_med: this.createForm.id_med,
            key_name: this.createForm.key_name,
            presentation: this.createForm.presentation,
            units: this.createForm.units,
            provider: this.createForm.provider,
            prescription: this.createForm.prescription || null,
            price: this.createForm.price,
            sale_price: this.createForm.sale_price
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        await this.getInitialData()
        this.$toast.success('El registro se ha creado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    setToDelete(row) {
      this.rowSelected = row
      const modal = this.$refs.deleteRow
      cash(modal).modal('show')
    },
    async deleteAction() {
      const modal = this.$refs.deleteRow
      cash(modal).modal('hide')
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-medicine/${this.rowSelected.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.getInitialData()
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    setToEdit(row) {
      this.rowSelected = row
      this.editForm = {
        name: this.rowSelected.name,
        id_med: this.rowSelected.id_med,
        key_name: this.rowSelected.key_name,
        presentation: this.rowSelected.presentation,
        units: this.rowSelected.units,
        provider: this.rowSelected.provider,
        prescription: this.rowSelected.prescription || '',
        price: this.rowSelected.price,
        sale_price: this.rowSelected.sale_price
      }
      this.v$.$reset()
      const modal = this.$refs.editRow
      cash(modal).modal('show')
    },
    async editAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.editRow
      cash(modal).modal('hide')
      try {
        const body = {
          name: this.editForm.name,
          id_med: this.editForm.id_med,
          key_name: this.editForm.key_name,
          presentation: this.editForm.presentation,
          units: this.editForm.units,
          provider: this.editForm.provider,
          prescription: this.editForm.prescription || '',
          price: this.editForm.price,
          sale_price: this.editForm.sale_price
        }
        await this.axios.put(`/update-medicine/${this.rowSelected.id}`, body, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.getInitialData()
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async downloadReport() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get('/medicine-file', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          },
          responseType: 'blob'
        })
        saveAs(
          response.data,
          `Medicinas Información ${moment().format('DD-MM-YYYY')}.xlsx`
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    }
  },
  computed: {
    filteredElements() {
      if (this.medicines) {
        let elements = this.medicines
        if (this.search && this.search.length) {
          elements = elements.filter(
            row =>
              row.name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.key_name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.provider
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.price.toString().includes(this.search.trim()) ||
              row.sale_price.toString().includes(this.search.trim())
          )
        }
        return elements
      }
      return []
    },
    elements: function() {
      if (this.filteredElements) {
        const takeElements =
          this.elementsByPage * this.page - this.filteredElements.length < 0
            ? this.elementsByPage * this.page
            : this.filteredElements.length
        return this.filteredElements.slice(
          this.elementsByPage * this.page - this.elementsByPage,
          takeElements
        )
      }
      return []
    },
    pages: function() {
      return this.filteredElements
        ? Math.ceil(this.filteredElements.length / this.elementsByPage)
        : 1
    },
    totalGroups: function() {
      return Math.ceil(this.pages / this.maxShowButtonPages)
    }
  }
}
</script>
